import Box from '@mui/material/Box';

const colors = {
  white: 'background.default',
  green: 'background.paper',
  darkBlue: 'background.darkBlue',
};

export default function Background({ backgroundColor = 'white', sx, children }: BackgroundProps) {
  return <Box sx={{ ...sx, backgroundColor: colors[backgroundColor] }}>{children}</Box>;
}

export type BackgroundColor = 'white' | 'green' | 'darkBlue';

export interface BackgroundProps {
  backgroundColor?: BackgroundColor;
  children?: React.ReactNode;
  sx?: {
    backgroundImage: string;
    backgroundRepeat: string;
    backgroundPosition: string;
    backgroundSize?: string;
    minHeight?: string;
    mt?: string;
  };
}
